import URL_ROUTE from '../constants/index';

class Api {
    async buscarCotizacion(nro) {
        let data = {
            nro: nro != '' ? nro : '-'
        }
        const query = await fetch(`${URL_ROUTE.BUSCARCOTIZACION}`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        return query
    }

    async guardarAprobacionCotizacion(nro, aprobado) {
        let data = {
            nro: nro != '' ? nro : '-',
            aprobado: aprobado
        }
        const query = await fetch(`${URL_ROUTE.GUARDARAPROBACIONCOTIZACION}`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        return query
    }

}

export default new Api();
